import { createSelector } from "@reduxjs/toolkit";
import { getCartList } from "./cart";
import { getPaymentDataList } from "./payment";

export const getCartTotalAmount = createSelector(getCartList, (list) => {
  const amounts = list.map((cartItem) => {
    return Number(cartItem.saleAmt ?? 0);
  });

  return amounts.reduce((sum, current) => sum + current, 0);
});

export const getIsInstallmentPaymentProgress = createSelector(
  getPaymentDataList,
  getCartTotalAmount,
  (paymentDataList, totalAmount) => {
    const amounts = paymentDataList.map((item) => item.payAmt);
    const payAmount = amounts.reduce((sum, current) => sum + current, 0);
    return paymentDataList.length > 0 && payAmount < totalAmount;
  }
);

export const getRemainTotalAmount = createSelector(
  getPaymentDataList,
  getCartTotalAmount,
  (paymentDataList, totalAmount) => {
    const amounts = paymentDataList.map((item) => item.payAmt);

    const payAmount = amounts.reduce((sum, current) => sum + current, 0);
    return totalAmount - payAmount;
  }
);

export const getPayCompletedAmount = createSelector(
  getPaymentDataList,
  (paymentDataList) => {
    const amounts = paymentDataList.map((item) => item.payAmt);
    return amounts.reduce((sum, current) => sum + current, 0);
  }
);
